import FormCompose from './form-compose';

export default class DmCompose extends FormCompose
{
    constructor()
    {
        super();

        // click on a form-check
        $('form .questions').on('click', '.form-check > input', (e) => {
            this.clickFormCheckInput(e);
        });

        // click on sections tab
        $('#sectionsTab > li').on('click', '> a.nav-link', (e) => {
            this.clickSectionTab(e);
        });

        // click submit (get my guide)
        $('#submit').on('click', (e) => {
            this.submit();
        });

        // click cancel (start over)
        $('#cancel').on('click', (e) => {
            this.cancel();
        });

        // create the graphs
        let currentBaseElement    = document.getElementById('current-dm');
        let currentScoreElement   = document.getElementById('current-dm-score');
        let projectedBaseElement  = document.getElementById('projected-dm');
        let projectedScoreElement = document.getElementById('projected-dm-score');

        let baseOptions = {
            type: 'doughnut',
            data: {
                labels: ['Level 1', 'Level 2', 'Level 3', 'Level 4'],
                datasets: [{
                    data: [25, 25, 25, 25],
                    backgroundColor: ['#132952', '#132952', '#132952', '#132952'],
                    borderColor: ['#27395A', '#27395A', '#27395A', '#27395A'],
                    borderWidth: 10
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                events: [],
                rotation: -130,
                circumference: 260,
                cutout: 99,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                }
            }
        };
        let scoreOptions = {
            type: 'doughnut',
            data: {
                labels: ['Level 1', 'Level 2', 'Level 3', 'Level 4'],
                datasets: [{
                    data: [25, 25, 25, 25],
                    backgroundColor: ['rgba(255,0,0,0)', 'rgba(255,0,0,0)', 'rgba(255,0,0,0)', 'rgba(255,0,0,0)'],
                    borderColor: ['#27395A', '#27395A', '#27395A', '#27395A'],
                    borderWidth: 10
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                events: [],
                rotation: -130,
                circumference: 260,
                cutout: 80,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                }
            }
        };

        this.currentBaseChart   = new Chart(currentBaseElement, baseOptions);
        this.projectedBaseChart = new Chart(projectedBaseElement, baseOptions);

        let haveOptions = jQuery.extend(true, {}, scoreOptions);
        let needOptions = jQuery.extend(true, {}, scoreOptions);

        this.scoreChart = {
            'have': new Chart(currentScoreElement, haveOptions),
            'need': new Chart(projectedScoreElement, needOptions),
        };

        // handle the sticky graphs
        let $graphs = $('#graphs');

        let stickyOffset = $graphs.offset().top - 83;

        $(window).scroll(() => {
            let scroll = $(window).scrollTop();

            if (scroll >= stickyOffset) {
                this.stick();
            }
            else {
                this.unstick();
            }
        });

    }

    stick()
    {
        let $graphs = $('#graphs');

        if (!$graphs.hasClass('stuck')) {
            $graphs.addClass('stuck');

            this.currentBaseChart.options.cutout = 50;
            this.scoreChart['have'].options.cutout = 40;
            this.scoreChart['need'].options.cutout = 40;
        }
    }

    unstick()
    {
        let $graphs = $('#graphs');

        if ($graphs.hasClass('stuck')) {
            $graphs.removeClass('stuck');

            this.currentBaseChart.options.cutout = 99;
            this.scoreChart['have'].options.cutout = 80;
            this.scoreChart['need'].options.cutout = 80;
        }
    }

    clickFormCheckInput(event)
    {
        let $input = $(event.currentTarget);
        let bucket = $input.attr('data-bucket');

        let s = $input.attr('data-section');
        let q = $input.attr('data-question');

        if (bucket == 'have') {
            pointsConfig['have'][s][q]['currentPoints'] = $input.attr('data-points');
            pointsConfig['need'][s][q]['currentPoints'] = $input.attr('data-points');
        }
        if (bucket == 'need') {
            pointsConfig['have'][s][q]['currentPoints'] = 0;
            pointsConfig['need'][s][q]['currentPoints'] = $input.attr('data-points');
        }

        this.updateScoresAndLevels()
    }

    clickSectionTab(event)
    {
        let $anchor = $(event.currentTarget);

        let currentSectionIndex = $anchor.attr('id');
        currentSectionIndex = currentSectionIndex.substring(4); // remove tab-

        let total = pointsConfig['have'][currentSectionIndex]['total'];

        $('#have-score .totals > span.total').text(total);
        $('#need-score .totals > span.total').text(total);

        this.updateScoresAndLevels()
    }

    updateScoresAndLevels()
    {
        let buckets = ['have', 'need'];

        let currentSectionIndex = $('#sectionsTab > li.nav-item > a.active').attr('id');
        currentSectionIndex = currentSectionIndex.substring(4); // remove tab-

        ['have', 'need'].forEach((bucket) => {
            let formTotalPoints = 0;
            let formPoints      = 0;

            let sectionTotalPoints = 0;
            let sectionPoints      = 0;

            pointsConfig[bucket].forEach((section, sectionIndex) => {
                for (const [questionIndex, question] of Object.entries(pointsConfig[bucket][sectionIndex])) {
                    if (questionIndex == 'total') return;

                    let totalPoints = pointsConfig[bucket][sectionIndex][questionIndex]['total'];

                    if ('currentPoints' in pointsConfig[bucket][sectionIndex][questionIndex]) {
                        let currentPoints = pointsConfig[bucket][sectionIndex][questionIndex]['currentPoints'];

                        formPoints += currentPoints;

                        if (currentSectionIndex == pointsConfig['sectionParentLkup'][sectionIndex]) sectionPoints += currentPoints;
                    }

                    formTotalPoints += totalPoints;

                    if (currentSectionIndex == pointsConfig['sectionParentLkup'][sectionIndex]) sectionTotalPoints += totalPoints;
                }
            });

            // Update points out of text
            $('#' + bucket + '-score .totals > span.score').text(sectionPoints);

            let formScore = 0;

            if (formPoints > 0) {
                formScore = Math.round((formPoints / formTotalPoints) * 100);
            }

            $('#form-points').val(formPoints);
            $('#form-score').val(formScore);

            // Figure out the levels
            let level1 = 1;
            let level2 = Math.round(sectionTotalPoints * .25);
            let level3 = Math.round(sectionTotalPoints * .5);
            let level4 = Math.round(sectionTotalPoints * .75);

            // Update the current/projected level
            if (sectionPoints >= level4) {
                this.scoreChart[bucket].data.datasets[0].backgroundColor[3] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[2] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[1] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[0] = '#4893ef';

                if (bucket == 'need') {
                    this.scoreChart['need'].data.datasets[0].backgroundColor[3] = '#ea4f28';
                }

                $('#' + bucket + '-score .level').text(4);
            }
            else if (sectionPoints >= level3) {
                this.scoreChart[bucket].data.datasets[0].backgroundColor[3] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[2] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[1] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[0] = '#4893ef';

                if (bucket == 'need') {
                    this.scoreChart['need'].data.datasets[0].backgroundColor[2] = '#ea4f28';
                }
                $('#' + bucket + '-score .level').text(3);
            }
            else if (sectionPoints >= level2) {
                this.scoreChart[bucket].data.datasets[0].backgroundColor[3] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[2] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[1] = '#4893ef';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[0] = '#4893ef';

                if (bucket == 'need') {
                    this.scoreChart['need'].data.datasets[0].backgroundColor[1] = '#ea4f28';
                }
                $('#' + bucket + '-score .level').text(2);
            }
            else if (sectionPoints >= level1) {
                this.scoreChart[bucket].data.datasets[0].backgroundColor[3] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[2] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[1] = 'rgba(255,0,0,0)';

                if (bucket == 'have') {
                    this.scoreChart['have'].data.datasets[0].backgroundColor[0] = '#4893ef';
                }
                if (bucket == 'need') {
                    this.scoreChart['need'].data.datasets[0].backgroundColor[0] = '#ea4f28';
                }
                $('#' + bucket + '-score .level').text(1);
            }
            else if (sectionPoints == 0) {
                this.scoreChart[bucket].data.datasets[0].backgroundColor[3] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[2] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[1] = 'rgba(255,0,0,0)';
                this.scoreChart[bucket].data.datasets[0].backgroundColor[0] = 'rgba(255,0,0,0)';
                $('#' + bucket + '-score .level').text(0);
            }

            this.scoreChart[bucket].update();
        });
    }

    cancel(event)
    {
        $('form.keepAlive')[0].reset();

        ['have', 'need'].forEach((bucket) => {
            pointsConfig[bucket].forEach((section, sectionIndex) => {
                for (const [questionIndex, question] of Object.entries(pointsConfig[bucket][sectionIndex])) {
                    if (questionIndex == 'total') return;

                    if ('currentPoints' in pointsConfig[bucket][sectionIndex][questionIndex]) {
                        delete pointsConfig[bucket][sectionIndex][questionIndex]['currentPoints'];
                    }
                }
            });
        });

        this.updateScoresAndLevels()
    }

    submit(event)
    {
        $('form.keepAlive').submit();
    }
}
